import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { FAQS } from "@/content";

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="relative py-20 lg:py-28 bg-brand-cloud">
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <SectionHead
          center
          eyebrow="Preguntas frecuentes"
          title="Todo lo que tu clínica pregunta antes de comprar"
        />

        <div className="mt-12 space-y-4" data-testid="faq-list">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={f.q} delay={i * 0.05}>
                <div
                  data-testid={`faq-item-${i}`}
                  className={`rounded-2xl border bg-white transition-colors duration-300 overflow-hidden ${
                    isOpen ? "border-brand-orange/50 shadow-[0_18px_45px_-25px_rgba(255,87,34,0.4)]" : "border-slate-200"
                  }`}
                >
                  <button
                    data-testid={`faq-toggle-${i}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-6 px-6 sm:px-7 py-5 text-left"
                  >
                    <span className="font-display text-base sm:text-lg font-bold text-brand-ink">{f.q}</span>
                    <motion.span
                      animate={{ rotate: isOpen ? 45 : 0 }}
                      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                      className={`inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-colors duration-300 ${
                        isOpen ? "bg-brand-orange border-brand-orange text-white" : "border-slate-300 text-slate-500"
                      }`}
                    >
                      <Plus className="h-4 w-4" />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        data-testid={`faq-answer-${i}`}
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                      >
                        <p className="px-6 sm:px-7 pb-6 text-slate-600 leading-relaxed">{f.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
